/**
 * HTML escape — single source of truth. Replaces three duplicate implementations
 * across global-utils.js, confirm-notices.js, and inline copies in feed-cards.js.
 *
 * Coerces `null` / `undefined` / numbers to safe strings. Strict-mode safe.
 */

const REPLACEMENTS = /** @type {Record<string, string>} */ ({
  '&': '&amp;',
  '<': '&lt;',
  '>': '&gt;',
  '"': '&quot;',
  "'": '&#39;',
});

/**
 * @param {unknown} value
 * @returns {string}
 */
export function escape(value) {
  return String(value ?? '').replace(/[&<>"']/g, (c) => REPLACEMENTS[c]);
}

/** Alias matching the legacy `_esc` name for clarity at call sites. */
export const _esc = escape;
